export default "__VITE_ASSET__BF1AtkGb__"